import { UsageStatisticsEntry } from '@griply/types';

import { diffInUtcDays, startOfUtcDay } from '../utc-day';

export const PMF_USAGE_RETENTION_DAYS = 30;

export type RecordPmfUsageResult = {
  entries: UsageStatisticsEntry[];
  changed: boolean;
};

const prune = (
  entries: UsageStatisticsEntry[],
  now: Date,
): UsageStatisticsEntry[] =>
  entries.filter(
    (entry) => diffInUtcDays(now, entry.date) <= PMF_USAGE_RETENTION_DAYS,
  );

export const recordPmfSession = (
  entries: UsageStatisticsEntry[],
  now: Date,
): RecordPmfUsageResult => {
  const todayMs = startOfUtcDay(now).getTime();
  const hasToday = entries.some(
    (entry) => startOfUtcDay(entry.date).getTime() === todayMs,
  );

  if (hasToday) {
    const pruned = prune(entries, now);
    return { entries: pruned, changed: pruned.length !== entries.length };
  }

  const withToday = [
    ...entries,
    { date: startOfUtcDay(now), completionCount: 0 },
  ];
  return { entries: prune(withToday, now), changed: true };
};

export const recordPmfCompletion = (
  entries: UsageStatisticsEntry[],
  now: Date,
): RecordPmfUsageResult => {
  const todayMs = startOfUtcDay(now).getTime();
  const hasToday = entries.some(
    (entry) => startOfUtcDay(entry.date).getTime() === todayMs,
  );

  const updated = hasToday
    ? entries.map((entry) =>
        startOfUtcDay(entry.date).getTime() === todayMs
          ? { ...entry, completionCount: entry.completionCount + 1 }
          : entry,
      )
    : [...entries, { date: startOfUtcDay(now), completionCount: 1 }];

  return { entries: prune(updated, now), changed: true };
};
